/**
 * @fileoverview Index file for all migrated primitive agents.
 * Each primitive agent is a single LLM call that performs one atomic operation.
 */

// Import > Story
export { definition as chapterExtractorV2 } from './story-import/chapter-extractor-v2';
export { definition as chapterExtractorChunkedV2 } from './story-import/chapter-extractor-chunked-v2';
export { definition as plotExtractorV2 } from './story-import/plot-extractor-v2';
export { definition as plotSynopsisExtractorV3 } from './story-import/plot-synopsis-extractor-v3';
export { definition as plotSynopsisExtractorChunkedV3 } from './story-import/plot-synopsis-extractor-chunked-v3';
export { definition as plotSynopsisMergeV3 } from './story-import/plot-synopsis-merge-v3';
export { definition as singleChapterExtractorV2 } from './story-import/single-chapter-extractor-v2';
export { definition as shortStoryExtractor } from './story-import/short-story-extractor';
export { definition as storyDnaExtractorV2 } from './story-import/story-dna-extractor-v2';
export { definition as aStorylineExtractorV1 } from './story-import/a-storyline-extractor-v1';
export { definition as bStorylineExtractorV1 } from './story-import/b-storyline-extractor-v1';
export { definition as cStorylineExtractorV1 } from './story-import/c-storyline-extractor-v1';
export { definition as plotThreadExtractorV1 } from './story-import/plot-thread-extractor-v1';
export { definition as robustChapterFormatterV1 } from './story-import/robust-chapter-formatter-v1';
export { definition as chapterBoundaryDetectorV1 } from './story-import/chapter-boundary-detector-v1';
export { definition as chapterMetadataExtractorV1 } from './story-import/chapter-metadata-extractor-v1';
export { definition as genreDetectorV2 } from './style-guides/genre-detector-v2';

// Import > Characters
export { definition as characterExtractorFullV2 } from './story-import/character-extractor-full-v2';
export { definition as characterExtractorTargetedV2 } from './story-import/character-extractor-targeted-v2';
export { definition as characterExtractorChunkedV2 } from './story-import/character-extractor-chunked-v2';
export { definition as characterArcExtractorV3 } from './story-import/character-arc-extractor-v3';

// Entities > Characters > Creation
export { definition as characterArcCreationV2 } from './characters/character-arc-creation-v2';
export { definition as characterDetailsIdeationV2 } from './characters/character-details-ideation-v2';
export { definition as characterDetailsMultimodalGeneratorV3 } from './characters/character-details-multimodal-generator-v3';
export { definition as characterIdeationV2 } from './characters/character-ideation-v2';
export { definition as characterModifierV1 } from './characters/character-modifier-v1';

// Entities > Characters > Analysis
export { definition as characterSnapshotterSingleV2 } from './snapshots/character-snapshotter-single-v2';
export { definition as personalityMatcherV2 } from './inspirations/personality-matcher-v2';

// Entities > World > V3 Objects
export { definition as worldObjectIdeationV3 } from './world-object-ideation-v3';
export { definition as worldObjectDetailsIdeationV3 } from './world-object-details-ideation-v3';
export { definition as worldObjectDetailsGeneratorV3 } from './world-object-details-generator-v3';
export { definition as worldObjectSnapshotterV3 } from './world-object-snapshotter-v3';

// Entities > World > V3 Places
export { definition as worldPlaceIdeationV3 } from './world-place-ideation-v3';
export { definition as worldPlaceSnapshotterV3 } from './world-place-snapshotter-v3';
export { definition as worldPlaceDetailsIdeationV3 } from './world-place-details-ideation-v3';
export { definition as worldPlaceDetailsGeneratorV3 } from './world-place-details-generator-v3';

// Entities > World > V3 Sets
export { definition as worldSetIdeationV3 } from './world-set-ideation-v3';
export { definition as worldSetSnapshotterV3 } from './world-set-snapshotter-v3';
export { definition as worldSetDetailsIdeationV3 } from './world-set-details-ideation-v3';
export { definition as worldSetDetailsGeneratorV3 } from './world-set-details-generator-v3';

// Entities > World > V3 Events
export { definition as worldEventIdeationV3 } from './world-event-ideation-v3';
export { definition as worldEventSnapshotterV3 } from './world-event-snapshotter-v3';
export { definition as worldEventDetailsIdeationV3 } from './world-event-details-ideation-v3';
export { definition as worldEventDetailsGeneratorV3 } from './world-event-details-generator-v3';

// Entities > World > V3 Organizations
export { definition as worldOrganizationIdeationV3 } from './world-organization-ideation-v3';
export { definition as worldOrganizationSnapshotterV3 } from './world-organization-snapshotter-v3';
export { definition as worldOrganizationDetailsIdeationV3 } from './world-organization-details-ideation-v3';
export { definition as worldOrganizationDetailsGeneratorV3 } from './world-organization-details-generator-v3';

// Entities > World > V3 Species
export { definition as worldSpeciesIdeationV3 } from './world-species-ideation-v3';
export { definition as worldSpeciesSnapshotterV3 } from './world-species-snapshotter-v3';
export { definition as worldSpeciesDetailsIdeationV3 } from './world-species-details-ideation-v3';
export { definition as worldSpeciesDetailsGeneratorV3 } from './world-species-details-generator-v3';

// Entities > World > V3 Systems
export { definition as worldSystemIdeationV3 } from './world-system-ideation-v3';
export { definition as worldSystemSnapshotterV3 } from './world-system-snapshotter-v3';
export { definition as worldSystemDetailsIdeationV3 } from './world-system-details-ideation-v3';
export { definition as worldSystemDetailsGeneratorV3 } from './world-system-details-generator-v3';

// Entities > World > V3 Extraction
export { definition as worldElementCoreDetectorV3 } from './story-import/world-element-core-detector-v3';
export { definition as worldElementRareDetectorV3 } from './story-import/world-element-rare-detector-v3';
export { definition as worldElementDetailerV3 } from './story-import/world-element-detailer-v3';
export { definition as worldElementChunkedExtractorV3 } from './story-import/world-element-chunked-extractor-v3';

// Meta > Style
export { definition as generateCustomStyleGuideV2 } from './style-guides/generate-custom-style-guide-v2';
export { definition as styleAnalyzerV2 } from './style-guides/style-analyzer-v2';
export { definition as styleGuardrailsGeneratorV2 } from './style-guides/style-guardrails-generator-v2';
export { definition as templateGeneratorV2 } from './style-guides/template-generator-v2';

// Narrative > Prose
export { definition as chapterDrafterV2 } from './prose/chapter-drafter-v2';
export { definition as chapterDrafterV2Neutral } from './prose/chapter-drafter-v2-neutral';
export { definition as singleChapterDrafter } from './prose/single-chapter-drafter';
export { definition as draftRefinerV2 } from './editing/draft-refiner-v2';
export { definition as draftBlenderV1 } from './editing/draft-blender-v1';
export { definition as proseContinuerGuided } from './prose/prose-continuer-guided';
export { definition as proseContinuerGuidedNeutral } from './prose/prose-continuer-guided-neutral';
export { definition as proseContinuerDiscovery } from './prose/prose-continuer-discovery';
export { definition as proseContinuerDiscoveryNeutral } from './prose/prose-continuer-discovery-neutral';
export { definition as selectionReviserV2 } from './editing/selection-reviser-v2';
export { definition as proseExpanderV2 } from './prose/prose-expander-v2';
export { definition as proseShortenerV2 } from './prose/prose-shortener-v2';
export { definition as povChangerV2 } from './editing/pov-changer-v2';
export { definition as styleAlignerV2 } from './editing/style-aligner-v2';

// Narrative > Prose > Critique
export { definition as critiqueProseFlow } from './critique/critique-prose-flow';
export { definition as critiqueSensoryAtmosphere } from './critique/critique-sensory-atmosphere';
export { definition as critiqueVoiceEmotion } from './critique/critique-voice-emotion';
export { definition as critiqueDialogue } from './critique/critique-dialogue';

// Narrative > Prose > Refinement
export { definition as autoGather } from './editing/auto-gather';
export { definition as refineSynthesizer } from './editing/refine-synthesizer';

// Narrative > Prose > Judgment
export { definition as draftJudgeV2 } from './editing/draft-judge-v2';
export { definition as proseComparerV2 } from './prose/prose-comparer-v2';

// Narrative > Plot
export { definition as povSuggesterV2 } from './story-planning/pov-suggester-v2';
export { definition as plotTypeSuggesterV2 } from './story-planning/plot-type-suggester-v2';
export { definition as plotIdeasGeneratorV2 } from './story-planning/plot-ideas-generator-v2';
export { definition as shortStoryPlannerV4 } from './story-planning/short-story-planner-v4';
export { definition as storylinesPlannerV1 } from './story-planning/storylines-planner-v1';
export { definition as storylineIdeationV1 } from './story-planning/storyline-ideation-v1';
export { definition as plotPlannerV1 } from './story-planning/plot-planner-v1';
export { definition as plotExpanderV1 } from './story-planning/plot-expander-v1';
export { definition as storylineExpanderV1 } from './story-planning/storyline-expander-v1';
export { definition as storylineFinderV1 } from './story-planning/storyline-finder-v1';
export { definition as sequelIdeasGeneratorV2 } from './story-planning/sequel-ideas-generator-v2';
export { definition as inspirationIdeasGeneratorV2 } from './story-planning/inspiration-ideas-generator-v2';

// Narrative > Chapters
export { definition as nextChapterSuggesterV2 } from './chapter-workspace/next-chapter-suggester-v2';
export { definition as storyBeyondSuggesterV2 } from './story-planning/story-beyond-suggester-v2';
export { definition as chapterPlannerV2 } from './chapter-workspace/chapter-planner-v2';
export { definition as chapterArchitectV2 } from './chapter-workspace/chapter-architect-v2';
export { definition as chapterArchitectRemainingV2 } from './chapter-workspace/chapter-architect-remaining-v2';
export { definition as sceneArchitectV2 } from './chapter-workspace/scene-architect-v2';
export { definition as scenesRebuilderV1 } from './story-updating/scenes-rebuilder-v1';
export { definition as chapterRebuilderV1 } from './story-updating/chapter-rebuilder-v1';
export { definition as divergenceReportV2 } from './story-updating/divergence-report-v2';
export { definition as divergenceReportShortV1 } from './story-updating/divergence-report-short-v1';
export { definition as storyFeedbackV1 } from './story-updating/story-feedback-v1';
export { definition as storyWeaknessesV1 } from './story-updating/story-weaknesses-v1';
export { definition as weaknessSolutionsV1 } from './story-updating/weakness-solutions-v1';
export { definition as distillChangesV1 } from './story-updating/distill-changes-v1';
export { definition as structuralSuggestionsV1 } from './story-updating/structural-suggestions-v1';
export { definition as storyModifierV1 } from './story-updating/story-modifier-v1';
export { definition as shortStoryModifierV1 } from './story-updating/short-story-modifier-v1';
export { definition as chapterSplitterV2 } from './chapter-workspace/chapter-splitter-v2';
export { definition as splitPointDetectorV1 } from './chapter-workspace/split-point-detector-v1';
export { definition as chapterRestructureV1 } from './chapter-workspace/chapter-restructure-v1';
export { definition as chapterEntityDetectorV2 } from './snapshots/chapter-entity-detector-v2';
export { definition as singleChapterStoryGeneratorV2 } from './chapter-workspace/single-chapter-story-generator-v2';
export { definition as plotSnapshotterV2 } from './snapshots/plot-snapshotter-v2';
export { definition as weaveSnapshotterV2 } from './snapshots/weave-snapshotter-v2';
export { definition as weaveSnapshotterShortV1 } from './snapshots/weave-snapshotter-short-v1';
export { definition as plotThreadSnapshotterV1 } from './snapshots/plot-thread-snapshotter-v1';
export { definition as continuityExtractorV2 } from './snapshots/continuity-extractor-v2';
export { definition as keyEventsExpanderV2 } from './chapter-workspace/key-events-expander-v2';
export { definition as keyEventsNeutralizerV1 } from './chapter-workspace/key-events-neutralizer-v1';

// Editing > Continuity
export { definition as chapterContinuityCheckerV2 } from './continuity/chapter-continuity-checker-v2';
export { definition as characterContinuityCheckerV2 } from './continuity/character-continuity-checker-v2';
export { definition as itemContinuityCheckerV2 } from './continuity/item-continuity-checker-v2';

// Visuals > Prompts
export { definition as storyImagePromptCreatorV2 } from './visuals/story-image-prompt-creator-v2';
export { definition as sceneExplorerV1 } from './visuals/scene-explorer-v1';
export { definition as scenePromptCreatorV1 } from './visuals/scene-prompt-creator-v1';
export { definition as characterImagePromptCreatorV2 } from './visuals/character-image-prompt-creator-v2';
export { definition as portraitImagePromptCreatorV2 } from './visuals/portrait-image-prompt-creator-v2';
export { definition as worldElementImagePromptCreatorV2 } from './visuals/world-element-image-prompt-creator-v2';

// Visuals > Images
export { definition as storyImageCreatorFalV2 } from './visuals/story-image-creator-fal-v2';
export { definition as characterImageCreatorFalV2 } from './visuals/character-image-creator-fal-v2';
export { definition as portraitImageCreatorFalV2 } from './visuals/portrait-image-creator-fal-v2';
export { definition as referenceImageCreatorFalV2 } from './visuals/reference-image-creator-fal-v2';
export { definition as imageEditorFalV2 } from './visuals/image-editor-fal-v2';
export { definition as worldElementImageCreatorFalV2 } from './visuals/world-element-image-creator-fal-v2';

// Visuals > Images > Analysis
export { definition as imageClassifierV1 } from './inspirations/image-classifier-v1';
export { definition as inspirationAttributeDeriverV1 } from './inspirations/inspiration-attribute-deriver-v1';

// Entities > Characters > Inspiration
export { definition as inspirationProfileGeneratorV1 } from './inspirations/inspiration-profile-generator-v1';

// Collect all primitive definitions for easy import
import { definition as chapterExtractorV2Def } from './story-import/chapter-extractor-v2';
import { definition as chapterExtractorChunkedV2Def } from './story-import/chapter-extractor-chunked-v2';
import { definition as plotExtractorV2Def } from './story-import/plot-extractor-v2';
import { definition as plotSynopsisExtractorV3Def } from './story-import/plot-synopsis-extractor-v3';
import { definition as plotSynopsisExtractorChunkedV3Def } from './story-import/plot-synopsis-extractor-chunked-v3';
import { definition as plotSynopsisMergeV3Def } from './story-import/plot-synopsis-merge-v3';
import { definition as singleChapterExtractorV2Def } from './story-import/single-chapter-extractor-v2';
import { definition as shortStoryExtractorDef } from './story-import/short-story-extractor';
import { definition as storyDnaExtractorV2Def } from './story-import/story-dna-extractor-v2';
import { definition as aStorylineExtractorV1Def } from './story-import/a-storyline-extractor-v1';
import { definition as bStorylineExtractorV1Def } from './story-import/b-storyline-extractor-v1';
import { definition as cStorylineExtractorV1Def } from './story-import/c-storyline-extractor-v1';
import { definition as plotThreadExtractorV1Def } from './story-import/plot-thread-extractor-v1';
import { definition as robustChapterFormatterV1Def } from './story-import/robust-chapter-formatter-v1';
import { definition as chapterBoundaryDetectorV1Def } from './story-import/chapter-boundary-detector-v1';
import { definition as chapterMetadataExtractorV1Def } from './story-import/chapter-metadata-extractor-v1';
import { definition as genreDetectorV2Def } from './style-guides/genre-detector-v2';
import { definition as characterExtractorFullV2Def } from './story-import/character-extractor-full-v2';
import { definition as characterExtractorTargetedV2Def } from './story-import/character-extractor-targeted-v2';
import { definition as characterExtractorChunkedV2Def } from './story-import/character-extractor-chunked-v2';
import { definition as characterArcExtractorV3Def } from './story-import/character-arc-extractor-v3';
// Entities > Characters > Creation
import { definition as characterArcCreationV2Def } from './characters/character-arc-creation-v2';
import { definition as characterDetailsIdeationV2Def } from './characters/character-details-ideation-v2';
import { definition as characterDetailsMultimodalGeneratorV3Def } from './characters/character-details-multimodal-generator-v3';
import { definition as characterIdeationV2Def } from './characters/character-ideation-v2';
import { definition as characterModifierV1Def } from './characters/character-modifier-v1';
// Entities > Characters > Analysis
import { definition as characterSnapshotterSingleV2Def } from './snapshots/character-snapshotter-single-v2';
import { definition as personalityMatcherV2Def } from './inspirations/personality-matcher-v2';
// Entities > World > V3 Objects
import { definition as worldObjectIdeationV3Def } from './world-object-ideation-v3';
import { definition as worldObjectDetailsIdeationV3Def } from './world-object-details-ideation-v3';
import { definition as worldObjectDetailsGeneratorV3Def } from './world-object-details-generator-v3';
import { definition as worldObjectSnapshotterV3Def } from './world-object-snapshotter-v3';
// Entities > World > V3 Places
import { definition as worldPlaceIdeationV3Def } from './world-place-ideation-v3';
import { definition as worldPlaceSnapshotterV3Def } from './world-place-snapshotter-v3';
import { definition as worldPlaceDetailsIdeationV3Def } from './world-place-details-ideation-v3';
import { definition as worldPlaceDetailsGeneratorV3Def } from './world-place-details-generator-v3';
// Entities > World > V3 Sets
import { definition as worldSetIdeationV3Def } from './world-set-ideation-v3';
import { definition as worldSetSnapshotterV3Def } from './world-set-snapshotter-v3';
import { definition as worldSetDetailsIdeationV3Def } from './world-set-details-ideation-v3';
import { definition as worldSetDetailsGeneratorV3Def } from './world-set-details-generator-v3';
// Entities > World > V3 Events
import { definition as worldEventIdeationV3Def } from './world-event-ideation-v3';
import { definition as worldEventSnapshotterV3Def } from './world-event-snapshotter-v3';
import { definition as worldEventDetailsIdeationV3Def } from './world-event-details-ideation-v3';
import { definition as worldEventDetailsGeneratorV3Def } from './world-event-details-generator-v3';
// Entities > World > V3 Organizations
import { definition as worldOrganizationIdeationV3Def } from './world-organization-ideation-v3';
import { definition as worldOrganizationSnapshotterV3Def } from './world-organization-snapshotter-v3';
import { definition as worldOrganizationDetailsIdeationV3Def } from './world-organization-details-ideation-v3';
import { definition as worldOrganizationDetailsGeneratorV3Def } from './world-organization-details-generator-v3';
// Entities > World > V3 Species
import { definition as worldSpeciesIdeationV3Def } from './world-species-ideation-v3';
import { definition as worldSpeciesSnapshotterV3Def } from './world-species-snapshotter-v3';
import { definition as worldSpeciesDetailsIdeationV3Def } from './world-species-details-ideation-v3';
import { definition as worldSpeciesDetailsGeneratorV3Def } from './world-species-details-generator-v3';
// Entities > World > V3 Systems
import { definition as worldSystemIdeationV3Def } from './world-system-ideation-v3';
import { definition as worldSystemSnapshotterV3Def } from './world-system-snapshotter-v3';
import { definition as worldSystemDetailsIdeationV3Def } from './world-system-details-ideation-v3';
import { definition as worldSystemDetailsGeneratorV3Def } from './world-system-details-generator-v3';
// Entities > World > V3 Extraction
import { definition as worldElementCoreDetectorV3Def } from './story-import/world-element-core-detector-v3';
import { definition as worldElementRareDetectorV3Def } from './story-import/world-element-rare-detector-v3';
import { definition as worldElementDetailerV3Def } from './story-import/world-element-detailer-v3';
import { definition as worldElementChunkedExtractorV3Def } from './story-import/world-element-chunked-extractor-v3';
import { definition as generateCustomStyleGuideV2Def } from './style-guides/generate-custom-style-guide-v2';
import { definition as styleAnalyzerV2Def } from './style-guides/style-analyzer-v2';
import { definition as styleGuardrailsGeneratorV2Def } from './style-guides/style-guardrails-generator-v2';
import { definition as templateGeneratorV2Def } from './style-guides/template-generator-v2';
import { definition as chapterDrafterV2Def } from './prose/chapter-drafter-v2';
import { definition as chapterDrafterV2NeutralDef } from './prose/chapter-drafter-v2-neutral';
import { definition as singleChapterDrafterDef } from './prose/single-chapter-drafter';
import { definition as draftRefinerV2Def } from './editing/draft-refiner-v2';
import { definition as draftBlenderV1Def } from './editing/draft-blender-v1';
import { definition as proseContinuerGuidedDef } from './prose/prose-continuer-guided';
import { definition as proseContinuerGuidedNeutralDef } from './prose/prose-continuer-guided-neutral';
import { definition as proseContinuerDiscoveryDef } from './prose/prose-continuer-discovery';
import { definition as proseContinuerDiscoveryNeutralDef } from './prose/prose-continuer-discovery-neutral';
import { definition as selectionReviserV2Def } from './editing/selection-reviser-v2';
import { definition as proseExpanderV2Def } from './prose/prose-expander-v2';
import { definition as proseShortenerV2Def } from './prose/prose-shortener-v2';
import { definition as povChangerV2Def } from './editing/pov-changer-v2';
import { definition as styleAlignerV2Def } from './editing/style-aligner-v2';
// Narrative > Prose > Critique
import { definition as critiqueProseFlowDef } from './critique/critique-prose-flow';
import { definition as critiqueSensoryAtmosphereDef } from './critique/critique-sensory-atmosphere';
import { definition as critiqueVoiceEmotionDef } from './critique/critique-voice-emotion';
import { definition as critiqueDialogueDef } from './critique/critique-dialogue';
// Narrative > Prose > Refinement
import { definition as autoGatherDef } from './editing/auto-gather';
import { definition as refineSynthesizerDef } from './editing/refine-synthesizer';
// Narrative > Prose > Judgment
import { definition as draftJudgeV2Def } from './editing/draft-judge-v2';
import { definition as proseComparerV2Def } from './prose/prose-comparer-v2';
import { definition as povSuggesterV2Def } from './story-planning/pov-suggester-v2';
import { definition as plotTypeSuggesterV2Def } from './story-planning/plot-type-suggester-v2';
import { definition as plotIdeasGeneratorV2Def } from './story-planning/plot-ideas-generator-v2';
import { definition as shortStoryPlannerV4Def } from './story-planning/short-story-planner-v4';
import { definition as storylinesPlannerV1Def } from './story-planning/storylines-planner-v1';
import { definition as storylineIdeationV1Def } from './story-planning/storyline-ideation-v1';
import { definition as plotPlannerV1Def } from './story-planning/plot-planner-v1';
import { definition as plotExpanderV1Def } from './story-planning/plot-expander-v1';
import { definition as storylineExpanderV1Def } from './story-planning/storyline-expander-v1';
import { definition as storylineFinderV1Def } from './story-planning/storyline-finder-v1';
import { definition as sequelIdeasGeneratorV2Def } from './story-planning/sequel-ideas-generator-v2';
import { definition as inspirationIdeasGeneratorV2Def } from './story-planning/inspiration-ideas-generator-v2';
// Narrative > Chapters
import { definition as nextChapterSuggesterV2Def } from './chapter-workspace/next-chapter-suggester-v2';
import { definition as storyBeyondSuggesterV2Def } from './story-planning/story-beyond-suggester-v2';
import { definition as chapterPlannerV2Def } from './chapter-workspace/chapter-planner-v2';
import { definition as chapterArchitectV2Def } from './chapter-workspace/chapter-architect-v2';
import { definition as chapterArchitectRemainingV2Def } from './chapter-workspace/chapter-architect-remaining-v2';
import { definition as sceneArchitectV2Def } from './chapter-workspace/scene-architect-v2';
import { definition as scenesRebuilderV1Def } from './story-updating/scenes-rebuilder-v1';
import { definition as chapterRebuilderV1Def } from './story-updating/chapter-rebuilder-v1';
import { definition as divergenceReportV2Def } from './story-updating/divergence-report-v2';
import { definition as divergenceReportShortV1Def } from './story-updating/divergence-report-short-v1';
import { definition as storyFeedbackV1Def } from './story-updating/story-feedback-v1';
import { definition as storyWeaknessesV1Def } from './story-updating/story-weaknesses-v1';
import { definition as weaknessSolutionsV1Def } from './story-updating/weakness-solutions-v1';
import { definition as distillChangesV1Def } from './story-updating/distill-changes-v1';
import { definition as structuralSuggestionsV1Def } from './story-updating/structural-suggestions-v1';
import { definition as storyModifierV1Def } from './story-updating/story-modifier-v1';
import { definition as shortStoryModifierV1Def } from './story-updating/short-story-modifier-v1';
import { definition as chapterSplitterV2Def } from './chapter-workspace/chapter-splitter-v2';
import { definition as splitPointDetectorV1Def } from './chapter-workspace/split-point-detector-v1';
import { definition as chapterRestructureV1Def } from './chapter-workspace/chapter-restructure-v1';
import { definition as chapterEntityDetectorV2Def } from './snapshots/chapter-entity-detector-v2';
import { definition as singleChapterStoryGeneratorV2Def } from './chapter-workspace/single-chapter-story-generator-v2';
import { definition as plotSnapshotterV2Def } from './snapshots/plot-snapshotter-v2';
import { definition as weaveSnapshotterV2Def } from './snapshots/weave-snapshotter-v2';
import { definition as weaveSnapshotterShortV1Def } from './snapshots/weave-snapshotter-short-v1';
import { definition as plotThreadSnapshotterV1Def } from './snapshots/plot-thread-snapshotter-v1';
import { definition as continuityExtractorV2Def } from './snapshots/continuity-extractor-v2';
import { definition as keyEventsExpanderV2Def } from './chapter-workspace/key-events-expander-v2';
import { definition as keyEventsNeutralizerV1Def } from './chapter-workspace/key-events-neutralizer-v1';
// Editing > Continuity
import { definition as chapterContinuityCheckerV2Def } from './continuity/chapter-continuity-checker-v2';
import { definition as characterContinuityCheckerV2Def } from './continuity/character-continuity-checker-v2';
import { definition as itemContinuityCheckerV2Def } from './continuity/item-continuity-checker-v2';
// Visuals > Prompts
import { definition as storyImagePromptCreatorV2Def } from './visuals/story-image-prompt-creator-v2';
import { definition as sceneExplorerV1Def } from './visuals/scene-explorer-v1';
import { definition as scenePromptCreatorV1Def } from './visuals/scene-prompt-creator-v1';
import { definition as characterImagePromptCreatorV2Def } from './visuals/character-image-prompt-creator-v2';
import { definition as portraitImagePromptCreatorV2Def } from './visuals/portrait-image-prompt-creator-v2';
import { definition as worldElementImagePromptCreatorV2Def } from './visuals/world-element-image-prompt-creator-v2';
// Visuals > Images
import { definition as storyImageCreatorFalV2Def } from './visuals/story-image-creator-fal-v2';
import { definition as characterImageCreatorFalV2Def } from './visuals/character-image-creator-fal-v2';
import { definition as portraitImageCreatorFalV2Def } from './visuals/portrait-image-creator-fal-v2';
import { definition as referenceImageCreatorFalV2Def } from './visuals/reference-image-creator-fal-v2';
import { definition as imageEditorFalV2Def } from './visuals/image-editor-fal-v2';
import { definition as worldElementImageCreatorFalV2Def } from './visuals/world-element-image-creator-fal-v2';
// Visuals > Images > Analysis
import { definition as imageClassifierV1Def } from './inspirations/image-classifier-v1';
import { definition as inspirationAttributeDeriverV1Def } from './inspirations/inspiration-attribute-deriver-v1';
// Entities > Characters > Inspiration
import { definition as inspirationProfileGeneratorV1Def } from './inspirations/inspiration-profile-generator-v1';
export const PRIMITIVE_AGENT_DEFINITIONS = [
  // Import > Story
  chapterExtractorV2Def,
  chapterExtractorChunkedV2Def,
  plotExtractorV2Def,
  plotSynopsisExtractorV3Def,
  plotSynopsisExtractorChunkedV3Def,
  plotSynopsisMergeV3Def,
  singleChapterExtractorV2Def,
  shortStoryExtractorDef,
  storyDnaExtractorV2Def,
  aStorylineExtractorV1Def,
  bStorylineExtractorV1Def,
  cStorylineExtractorV1Def,
  plotThreadExtractorV1Def,
  robustChapterFormatterV1Def,
  chapterBoundaryDetectorV1Def,
  chapterMetadataExtractorV1Def,
  genreDetectorV2Def,
  // Import > Characters
  characterExtractorFullV2Def,
  characterExtractorTargetedV2Def,
  characterExtractorChunkedV2Def,
  characterArcExtractorV3Def,
  // Entities > Characters > Creation
  characterArcCreationV2Def,
  characterDetailsIdeationV2Def,
  characterDetailsMultimodalGeneratorV3Def,
  characterIdeationV2Def,
  characterModifierV1Def,
  // Entities > Characters > Analysis
  characterSnapshotterSingleV2Def,
  personalityMatcherV2Def,
  // Entities > World > V3 Objects
  worldObjectIdeationV3Def,
  worldObjectDetailsIdeationV3Def,
  worldObjectDetailsGeneratorV3Def,
  worldObjectSnapshotterV3Def,
  // Entities > World > V3 Places
  worldPlaceIdeationV3Def,
  worldPlaceSnapshotterV3Def,
  worldPlaceDetailsIdeationV3Def,
  worldPlaceDetailsGeneratorV3Def,
  // Entities > World > V3 Sets
  worldSetIdeationV3Def,
  worldSetSnapshotterV3Def,
  worldSetDetailsIdeationV3Def,
  worldSetDetailsGeneratorV3Def,
  // Entities > World > V3 Events
  worldEventIdeationV3Def,
  worldEventSnapshotterV3Def,
  worldEventDetailsIdeationV3Def,
  worldEventDetailsGeneratorV3Def,
  // Entities > World > V3 Organizations
  worldOrganizationIdeationV3Def,
  worldOrganizationSnapshotterV3Def,
  worldOrganizationDetailsIdeationV3Def,
  worldOrganizationDetailsGeneratorV3Def,
  // Entities > World > V3 Species
  worldSpeciesIdeationV3Def,
  worldSpeciesSnapshotterV3Def,
  worldSpeciesDetailsIdeationV3Def,
  worldSpeciesDetailsGeneratorV3Def,
  // Entities > World > V3 Systems
  worldSystemIdeationV3Def,
  worldSystemSnapshotterV3Def,
  worldSystemDetailsIdeationV3Def,
  worldSystemDetailsGeneratorV3Def,
  // Entities > World > V3 Extraction
  worldElementCoreDetectorV3Def,
  worldElementRareDetectorV3Def,
  worldElementDetailerV3Def,
  worldElementChunkedExtractorV3Def,
  // Meta > Style
  generateCustomStyleGuideV2Def,
  styleAnalyzerV2Def,
  styleGuardrailsGeneratorV2Def,
  templateGeneratorV2Def,
  // Narrative > Prose
  chapterDrafterV2Def,
  chapterDrafterV2NeutralDef,
  singleChapterDrafterDef,
  draftRefinerV2Def,
  draftBlenderV1Def,
  proseContinuerGuidedDef,
  proseContinuerGuidedNeutralDef,
  proseContinuerDiscoveryDef,
  proseContinuerDiscoveryNeutralDef,
  selectionReviserV2Def,
  proseExpanderV2Def,
  proseShortenerV2Def,
  povChangerV2Def,
  styleAlignerV2Def,
  // Narrative > Prose > Critique
  critiqueProseFlowDef,
  critiqueSensoryAtmosphereDef,
  critiqueVoiceEmotionDef,
  critiqueDialogueDef,
  // Narrative > Prose > Refinement
  autoGatherDef,
  refineSynthesizerDef,
  // Narrative > Prose > Judgment
  draftJudgeV2Def,
  proseComparerV2Def,
  // Narrative > Plot
  povSuggesterV2Def,
  plotTypeSuggesterV2Def,
  plotIdeasGeneratorV2Def,
  shortStoryPlannerV4Def,
  storylinesPlannerV1Def,
  storylineIdeationV1Def,
  plotPlannerV1Def,
  plotExpanderV1Def,
  storylineExpanderV1Def,
  storylineFinderV1Def,
  sequelIdeasGeneratorV2Def,
  inspirationIdeasGeneratorV2Def,
  // Narrative > Chapters
  nextChapterSuggesterV2Def,
  storyBeyondSuggesterV2Def,
  chapterPlannerV2Def,
  chapterArchitectV2Def,
  chapterArchitectRemainingV2Def,
  sceneArchitectV2Def,
  scenesRebuilderV1Def,
  chapterRebuilderV1Def,
  divergenceReportV2Def,
  divergenceReportShortV1Def,
  storyFeedbackV1Def,
  storyWeaknessesV1Def,
  weaknessSolutionsV1Def,
  distillChangesV1Def,
  structuralSuggestionsV1Def,
  storyModifierV1Def,
  shortStoryModifierV1Def,
  chapterSplitterV2Def,
  splitPointDetectorV1Def,
  chapterRestructureV1Def,
  chapterEntityDetectorV2Def,
  singleChapterStoryGeneratorV2Def,
  plotSnapshotterV2Def,
  weaveSnapshotterV2Def,
  weaveSnapshotterShortV1Def,
  plotThreadSnapshotterV1Def,
  continuityExtractorV2Def,
  keyEventsExpanderV2Def,
  keyEventsNeutralizerV1Def,
  // Editing > Continuity
  chapterContinuityCheckerV2Def,
  characterContinuityCheckerV2Def,
  itemContinuityCheckerV2Def,
  // Visuals > Prompts
  storyImagePromptCreatorV2Def,
  sceneExplorerV1Def,
  scenePromptCreatorV1Def,
  characterImagePromptCreatorV2Def,
  portraitImagePromptCreatorV2Def,
  worldElementImagePromptCreatorV2Def,
  // Visuals > Images
  storyImageCreatorFalV2Def,
  characterImageCreatorFalV2Def,
  portraitImageCreatorFalV2Def,
  referenceImageCreatorFalV2Def,
  imageEditorFalV2Def,
  worldElementImageCreatorFalV2Def,
  // Visuals > Images > Analysis
  imageClassifierV1Def,
  inspirationAttributeDeriverV1Def,
  // Entities > Characters > Inspiration
  inspirationProfileGeneratorV1Def,
];
